module.exports = __webpack_public_path__ + "img/404.8ca334e5.jpg";